module.exports = __webpack_public_path__ + "img/2.3ae61fc2.jpg";